import { render, staticRenderFns } from "./DashboardSideMenuStatus.vue?vue&type=template&id=26489484&scoped=true&"
import script from "./DashboardSideMenuStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardSideMenuStatus.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSideMenuStatus.vue?vue&type=style&index=0&id=26489484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26489484",
  null
  
)

export default component.exports